export const printAccountBook = (elementId, filenameData = {}) => {
    const el = document.getElementById(elementId);
    if (!el) {
        console.error(`Element not found: ${elementId}`);
        return;
    }

    const { year, month } = filenameData;

    // 1. 파일명 및 제목 생성
    const now = new Date();
    const timestamp =
        now.getFullYear().toString() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getHours()).padStart(2, '0');

    const docTitle = `수입지출내역서_${year}년${month}월_${timestamp}`;

    // 현재 페이지 제목 임시 교체 (안드로이드/PC 해결책)
    // 브라우저가 iframe 인쇄 시에도 부모 창의 제목을 파일명으로 쓰는 경우가 많음
    const originalTitle = document.title; // 원래 제목 저장
    document.title = docTitle;            // 파일명으로 제목 변경

    // 2. 인쇄 내용 가져오기
    const printContents = el.innerHTML;

    // 3. CSS 스타일 정의 (기존 스타일 유지)
    const styles = `
        /* 초기화 */
        * { box-sizing: border-box; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        body { font-family: "Noto Sans KR", sans-serif; margin: 0; padding: 0; background: #fff; font-size: 10pt; }
        
        /* A4 설정 */
        @page { size: A4 portrait; margin: 10mm; }
        .print-page-wrapper { width: 190mm; margin: 0 auto; }

        /* 타이틀 영역 */
        .header-section { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
        .main-title { font-size: 24pt; font-weight: 900; margin: 0; letter-spacing: 2px; }
        .sub-title { font-size: 12pt; margin-top: 5px; font-weight: bold; }

        /* 요약(합계) 테이블 */
        .summary-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid #000; }
        .summary-th { background-color: #f2f2f2; border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold; width: 16%; }
        .summary-td { border: 1px solid #000; padding: 8px; text-align: right; font-weight: bold; font-size: 12pt; width: 17%; }
        .text-primary { color: #007bff; }
        .text-danger { color: #dc3545; }

        /* 메인 리스트 테이블 */
        .list-table { width: 100%; border-collapse: collapse; border: 1px solid #000; table-layout: fixed; font-size: 9pt; }
        .list-table th { background-color: #eee; border: 1px solid #000; padding: 6px 2px; font-weight: bold; text-align: center; height: 30px; }
        .list-table td { border: 1px solid #000; padding: 4px 4px; vertical-align: middle; height: 25px; word-break: break-all; }

        /* 컬럼별 스타일 */
        .col-date { width: 10%; text-align: center; }
        .col-type { width: 8%; text-align: center; }
        .col-category { width: 12%; text-align: center; }
        .col-desc { width: auto; text-align: left; }
        .col-money { width: 12%; text-align: right; }
        .col-note { width: 15%; text-align: left; font-size: 8pt; color: #555; }

        .type-income { color: #007bff; font-weight: bold; }
        .type-expense { color: #dc3545; font-weight: bold; }
        
        /* 하단 푸터 */
        .footer-date { margin-top: 20px; text-align: right; font-size: 9pt; color: #555; }
    `;

    // 4. [변경점] Iframe 생성 (팝업 대신 사용)
    // 기존 iframe이 있다면 제거 후 재생성
    let iframe = document.getElementById('print-iframe');
    if (iframe) {
        document.body.removeChild(iframe);
    }

    iframe = document.createElement('iframe');
    iframe.id = 'print-iframe';

    // 화면에 보이지 않게 설정
    iframe.style.position = 'fixed';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '100vw'; // 화면 전체 너비
    iframe.style.height = '100vh'; // 화면 전체 높이
    iframe.style.zIndex = '-9999'; // 화면 맨 뒤로 숨김
    iframe.style.opacity = '0';    // 투명하게 만듦 (보이지 않음)
    iframe.style.border = 'none';
    iframe.style.pointerEvents = 'none'; // 클릭 방지

    document.body.appendChild(iframe);

    // 5. Iframe에 HTML 쓰기
    const doc = iframe.contentWindow.document;

    const html = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>${docTitle}</title>
            <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700;900&display=swap" rel="stylesheet">
            <style>${styles}</style>
        </head>
        <body>
            <div class="print-page-wrapper">
                ${printContents}
            </div>
        </body>
        </html>
    `;

    doc.open();
    doc.write(html);
    doc.close();

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // 아이폰이면 그냥 팝업(새 탭)으로 띄움 (가장 안전)
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('팝업 차단을 해제해주세요.');
            // 차단 시 제목 복구
            document.title = originalTitle;
            return;
        }

        printWindow.document.write(html);
        printWindow.document.close();
        // 약간의 딜레이 후 인쇄
        setTimeout(() => {
            // PDF 파일명 적용 (아이폰 팝업용)
            printWindow.document.title = docTitle;
            printWindow.focus();
            printWindow.print();
        }, 1000);
    } else {
        // 인쇄 실행 (모바일 렌더링 대기)
        setTimeout(() => {
            // 인쇄 직전에 Iframe 문서의 타이틀을 다시 한번 명시적으로 설정 ▼▼▼
            iframe.contentWindow.document.title = docTitle;
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }, 1000); // 1초 대기 후 인쇄
    }

    // 제목 복구 (인쇄 다이얼로그가 충분히 뜬 후 복구)
    // 너무 빨리 복구하면 파일명이 다시 원래대로 돌아갈 수 있으므로 3초 뒤 복구
    setTimeout(() => {
        document.title = originalTitle;
    }, 3000);
};
